import _ from "lodash";
import client from "lib/apolloClient/client";

import { getStudentCourseMapQuery } from "./StudentClassesFeedQueries";

export const getStudentCourseMapQueryFromCache = variables => {
  try {
    const result = client.readQuery({
      query: getStudentCourseMapQuery,
      variables,
    });

    return _.get(result, "node.courseMap", []);
  } catch (error) {
    return {};
  }
};
